import { useState } from "react";
import { Share2 } from "lucide-react";
import { ShareModal } from "./ShareModal";

/**
 * Share button for listings.
 * targetType: "product" | "request"
 * targetId: id
 * title: listing title (shown in modal + used in share text)
 * description: optional short description for share text
 * variant: "icon" (floating circular, used on cards) | "button" (inline pill)
 */
export const ShareButton = ({
  targetType,
  targetId,
  title,
  description,
  variant = "icon",
  stopPropagation = true,
  className = "",
}) => {
  const [open, setOpen] = useState(false);

  const path = targetType === "product" ? `/p/${targetId}` : `/r/${targetId}`;
  const url = typeof window !== "undefined" ? `${window.location.origin}${path}` : path;
  const text = description
    ? `${title} — ${description.slice(0, 120)}${description.length > 120 ? "…" : ""}`
    : title;

  const openModal = (e) => {
    if (stopPropagation) {
      e.stopPropagation();
      e.preventDefault();
    }
    setOpen(true);
  };

  const closeModal = () => setOpen(false);

  if (variant === "button") {
    return (
      <>
        <button
          type="button"
          onClick={openModal}
          data-testid={`share-btn-${targetType}-${targetId}`}
          className={`inline-flex items-center gap-1.5 rounded-full border border-border bg-white px-4 h-10 text-xs font-semibold hover:border-foreground/30 transition-colors ${className}`}
        >
          <Share2 className="h-3.5 w-3.5" strokeWidth={2} />
          Share
        </button>
        <ShareModal open={open} onClose={closeModal} title={title} url={url} text={text} />
      </>
    );
  }

  return (
    <>
      <button
        type="button"
        onClick={openModal}
        data-testid={`share-btn-${targetType}-${targetId}`}
        aria-label="Share"
        className={`inline-flex items-center justify-center h-9 w-9 rounded-full bg-white/95 backdrop-blur-sm border border-border shadow-sm hover:border-foreground/30 transition-colors ${className}`}
      >
        <Share2 className="h-4 w-4" strokeWidth={2} />
      </button>
      <ShareModal open={open} onClose={closeModal} title={title} url={url} text={text} />
    </>
  );
};
